import { createAction } from 'redux-actions'
import history from 'utils/history'
import * as selectors from 'selectors'
import {
  googleAuthProvider,
  twitterAuthProvider,
  facebookAuthProvider,
  getCurrentUser,
  db,
  auth as firebaseAuth,
} from 'utils/firebase'
import { get, pick } from 'lodash'

const SET_PROFILE = 'totalbalance/auth/SET_PROFILE'
const LOGOUT = 'totalbalance/auth/LOGOUT'
const LOGIN = 'totalbalance/auth/LOGIN'
const AUTH_RESET = 'totalbalance/auth/RESET'
const CHECK_AUTH = 'totalbalance/auth/CHECK_AUTH'
const AUTH_ERROR = 'totalbalance/auth/AUTH_ERROR'

const initialState = {
  checkAuth: true,
  currentUser: null,
  error: null,
}

export default function(state = initialState, action) {
  switch (action.type) {
    case LOGIN:
      return {
        error: get(state, 'currentUser.isAnonymous', true) ? state.error : null,
        checkAuth: false,
        currentUser: action.payload,
      }
    case AUTH_RESET:
    case AUTH_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    case LOGOUT:
      return {
        ...initialState,
        error: action.payload,
      }
    case SET_PROFILE:
      return {
        ...state,
        profile: action.payload,
      }
    case CHECK_AUTH:
      return {
        ...state,
        checkAuth: true,
      }
    default:
      return state
  }
}

export const auth = (email, password) => dispatch =>
  firebaseAuth
    .signInWithEmailAndPassword(email, password)
    .then(user => {
      dispatch(login(user))
    })
    .catch(error => dispatch(logout(error)))

const authWithProvider = provider =>
  getCurrentUser().then(user => {
    sessionStorage.setItem('previousUser', JSON.stringify(user))
    firebaseAuth.signInWithRedirect(provider)
  })

export const googleAuth = () => (dispatch, getState) =>
  authWithProvider(googleAuthProvider)
export const twitterAuth = () => (dispatch, getState) =>
  authWithProvider(twitterAuthProvider)
export const facebookAuth = () => (dispatch, getState) =>
  authWithProvider(facebookAuthProvider)

const fetchUserProfile = () => (dispatch, getState) =>
  // check if admin
  db
    .ref(`admins/${selectors.currentUserUid(getState())}`)
    .once('value')
    .then(snapshot => dispatch(setProfile({ isAdmin: !!snapshot.val() })))

const setProfile = createAction(SET_PROFILE)

export const login = payload => dispatch => {
  dispatch(createAction(LOGIN)(payload))
  if (!payload.isAnonymous && history.location.pathname === '/login') {
    history.push('/')
  }
  // create/update user account
  db.ref(`accounts/${payload.uid}`).set({
    ...pick(payload, [
      'uid',
      'displayName',
      'email',
      'emailVerified',
      'photoURL',
      'providerData',
      'refreshToken',
      'metadata',
    ]),
  })
  return dispatch(fetchUserProfile())
}

export const reset = createAction(AUTH_RESET)

export const logout = () => dispatch => {
  dispatch(createAction(LOGOUT)())
  firebaseAuth.signOut().then(() => {
    dispatch(signInAnonymously())
  })
}

export const authError = createAction(AUTH_ERROR)

const signInAnonymously = () => dispatch =>
  firebaseAuth.signInAnonymously().then(user => dispatch(login(user)))

export const checkAuth = () => dispatch => {
  dispatch({ type: CHECK_AUTH })
  return new Promise((resolve, reject) => {
    const previousUser = JSON.parse(sessionStorage.getItem('previousUser'))
    // we are authentificating
    if (previousUser) {
      sessionStorage.removeItem('previousUser')
    }
    firebaseAuth
      .getRedirectResult()
      .then(({ user, ...result }) => {
        // success
        if (user && !user.isAnonymous) {
          resolve(dispatch(login(user)))
          // merge account when sign in (async)
          if (previousUser.isAnonymous) {
            setTimeout(() => {
              db
                .ref(`funds/${previousUser.uid}`)
                .once('value')
                .then(snapshot => {
                  const previousFunds = snapshot.val()
                  if (previousFunds) {
                    Promise.all(
                      Object.values(previousFunds).map(fund =>
                        db.ref(`funds/${user.uid}`).push(fund)
                      )
                    )
                  }
                })
            })
          }
          // user is empty because it fails
        } else {
          getCurrentUser()
            .then(user => resolve(dispatch(login(user))))
            .catch(() => resolve(dispatch(signInAnonymously())))
        }
      })
      .catch(error => {
        dispatch(authError(error))
        getCurrentUser()
          .then(user => resolve(dispatch(login(user))))
          .catch(() => resolve(dispatch(signInAnonymously())))
      })
  })
}



// WEBPACK FOOTER //
// ./src/actions/auth.js